import { createContext, useContext } from "react";
import { useSelector } from "react-redux";

const PermissionContext = createContext();

const normalizeRoleName = (value) => {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/ı/g, 'i')
        .trim();
};

const getRoleName = (role) => {
    if (!role) {
        return '';
    }

    if (typeof role === 'string') {
        return role;
    }

    return role.name || role.role?.name || role.label || role.value || '';
};

export const PermissionProvider = ({ children }) => {
    const { user } = useSelector((state) => state.auth);
    const permissions = user?.yetkiler || [];

    const controlPermission = (permission) => {
        return permissions.includes(permission) 
    };

    const userRoleNames = [
        ...(Array.isArray(user?.roles) ? user.roles.map(getRoleName) : []),
        getRoleName(user?.role),
        getRoleName(user?.roleName),
        getRoleName(user?.type)
    ];
    const isManagerUser = userRoleNames.some((roleName) => ['yonetici', 'admin'].includes(normalizeRoleName(roleName)));

    return (
        <PermissionContext.Provider value={{ permissions, controlPermission, isManagerUser }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissionContext = () => useContext(PermissionContext);
